import { useAuthStore } from '@/stores/AuthStore.js';

export default async (to, from, next) => {
  const authenticated = await useAuthStore().checkAuth();
  const type = useAuthStore().type;

  const checkAccountType = (to, type) => {
    if (to.meta.accountType == type) return true;
    return false;
  };

  if (!authenticated) {
    useAuthStore().redirectToTokenAuth(next);
    return;
  }

  if (!checkAccountType(to, type)) {
    next(type == 'companyAccount' ? '/company/overview' : '/');
    return;
  }
  next();
};
